import { render, staticRenderFns } from "./Und.vue?vue&type=template&id=4925bff4"
import script from "./Und.vue?vue&type=script&lang=js"
export * from "./Und.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports